import * as pedestrianRightsApi from "../api/pedestrianRights.api";
import { WithFiltersAndPaging } from "../models/filters/WithFiltersAndPaging";
import { ForFleetManager } from "../models/ForFleetManager";
import { DateFilter } from "../components/DataTable/DataTableContext/DataTableContextProvider";
import { isNil, isUndefined } from "lodash";
import { FmpFilters } from "../constants/filtering.constants";
import { convertDateToIsoString } from "../utils/date.utils";
import { 
  clearDelegeeDetailsAction,
  disposeErrorAction,
  getPedestrianProductsFailureAction,
  getPedestrianProductsSuccessAction,
  inviteDelegeeFailureAction,
  inviteDelegeeRequestAction,
  inviteDelegeeSuccessAction,
  myProductsPedestrianRightsFailureAction, 
  myProductsPedestrianRightsRequestAction, 
  myProductsPedestrianRightsSuccessAction, 
  revokePedestrianRightsFailureAction, 
  revokePedestrianRightsRequestAction, 
  revokePedestrianRightsSuccessAction,
  deletePedestrianDelegeesFailureAction,
  deletePedestrianDelegeesRequestAction,
  deletePedestrianDelegeesSuccessAction,
   } from "../store/actions/pedestrianRights.actions";
import { AxiosError, AxiosResponse } from "axios";
import { AnyAction, Dispatch } from "redux";
import { InvitePedestrianRightRequestModel } from "../models/InvitePedestrianRightRequestModel";
import { PedestrianProductModel } from "../models/PedestrianProductModel";
import { RevokePedestrianRightsModel } from "../models/vehicle-assignments/RevokePedestrianRightsModel";
import { DeletePedestrianDelegeesModel } from "../models/vehicle-assignments/DeletePedestrianDelegeesModel";
import { toastTriggers } from "../ui/CustomToast/toastTriggers";

export function getPedestrianProducts(
  seasonTicketOwnerCrmId: string,
  language: string
) {
  return (dispatch: Dispatch<AnyAction>) => {
    pedestrianRightsApi.getPedestrianProducts(seasonTicketOwnerCrmId, language)
      .then((response: AxiosResponse<PedestrianProductModel[]>) => { 
        dispatch(getPedestrianProductsSuccessAction(response)); 
      })
      .catch((error: AxiosError) => { dispatch(getPedestrianProductsFailureAction(error)); })
    };
}

export function inviteDelegee(request: InvitePedestrianRightRequestModel,
  callback?: () => void){
  return (dispatch: Dispatch<AnyAction>) => {
    dispatch(inviteDelegeeRequestAction());

    pedestrianRightsApi.inviteDelegee(request)
      .then(() => { 
        dispatch(inviteDelegeeSuccessAction(request));

        if (!isUndefined(callback)) {
          callback();
        }
      })
      .catch((error: AxiosError) => { dispatch(inviteDelegeeFailureAction(error)); })
  }
}

export function clearDelegeeDetails(){
  return (dispatch: Dispatch<AnyAction>) => {
    dispatch(clearDelegeeDetailsAction);
  }
}

export function disposeError(){
  return (dispatch: Dispatch<AnyAction>) => {
    dispatch(disposeErrorAction);
  };
}

export function getDelegatedPedestrianRightsByFilter(req: WithFiltersAndPaging<ForFleetManager>) {
  const q = convertFiltersToGetDelegatedPedestrianRightsQuery(req);

  return (dispatch: Dispatch<AnyAction>) => {
  dispatch(myProductsPedestrianRightsRequestAction({ query: q }));

  pedestrianRightsApi.getDelegatedPedestrianRights(q)
    .then((response) => {
      dispatch(myProductsPedestrianRightsSuccessAction({
        query: q,
        totalPages: response.data.totalPages,
        totalRecords: response.data.totalRecords,
        data: response.data.delegatedPedestrianRights,
      }));
    })
    .catch((error: AxiosError) => {
      dispatch(myProductsPedestrianRightsFailureAction({ query: q })
      );
    })
  };
};

export function revokePedestrianRights(
  model: RevokePedestrianRightsModel,
  callback?: () => void
) {
  return (dispatch: Dispatch<AnyAction>) => {
    dispatch(revokePedestrianRightsRequestAction);

    pedestrianRightsApi
      .revokePedestrianRights(model)
      .then(() => {
        dispatch(revokePedestrianRightsSuccessAction(model));

        if (!isUndefined(callback)) {
          callback();
        }

        toastTriggers.success({
          content: {
            key: "parkingRights.revokePedestrianRight.success",
            options: { count: model.entryRightIds.length },
          },
        });
      })
      .catch((error: AxiosError) => {
        dispatch(revokePedestrianRightsFailureAction);

        toastTriggers.error({
          content: {
            key: "parkingRights.revokePedestrianRight.error",
          },
        });
      });
  };
};

export function deletePedestrianDelegees(
    model: DeletePedestrianDelegeesModel,
    callback?: () => void
) {
    return (dispatch: Dispatch<AnyAction>) => {
        dispatch(deletePedestrianDelegeesRequestAction);

        pedestrianRightsApi
            .deletePedestrianDelegees(model)
            .then(() => {
                dispatch(deletePedestrianDelegeesSuccessAction(model));

                if (!isUndefined(callback)) {
                    callback();
                }

                toastTriggers.success({
                    content: {
                        key: "parkingRights.deletePedestrianRight.success",
                        options: { count: model.delegeeIds.length },
                    },
                });
            })
            .catch((error: AxiosError) => {
                dispatch(revokePedestrianRightsFailureAction);

                toastTriggers.error({
                    content: {
                        key: "parkingRights.deletePedestrianRight.error",
                    },
                });
            });
    };
};

function convertFiltersToGetDelegatedPedestrianRightsQuery(
  r: WithFiltersAndPaging<ForFleetManager>): pedestrianRightsApi.GetDelegatedPedestrianRightsQuery {
  const { filters } = r;
  const invitationDateFilter = filters?.find((x) => x.key === FmpFilters.invitationDate)?.value as
    | DateFilter
    | undefined;

  const convertedInvitationDateFilter =
    isNil(invitationDateFilter) || isNil(invitationDateFilter.startDate)
      ? undefined
      : convertDateToIsoString(invitationDateFilter.startDate, invitationDateFilter.endDate);

  return {
    seasonTicketOwnerCrmId: r.entity.seasonTicketOwnerCrmId,
    placeId: Number(filters?.find((x) => x.key === FmpFilters.placeId)?.value),
    language: r.entity.language,
    page: r.pagination.pageNumber,
    pageSize: r.pagination.pageSize,
    invitationFrom: convertedInvitationDateFilter?.start,
    invitationTo: convertedInvitationDateFilter?.end,
    statuses: filters?.find((x) => x.key === FmpFilters.statuses)?.value as any,
    ascending: r.filters?.find((x) => x.key === FmpFilters.orderDesc)?.value === "false",
    email: filters?.find((x) => x.key === FmpFilters.email)?.value as any,
    name: filters?.find((x) => x.key === FmpFilters.name)?.value as any,
    pmcIds: filters?.find((x) => x.key === FmpFilters.products)?.value as any,
    sortBy: filters?.find((x) => x.key === FmpFilters.sortBy)?.value as any,
  };
}